import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import DashedTooltip from "components/UI/DashedTooltip";
import { returnUpDownClassname } from "utils/helpers";

const CalendarTradabilityCard = (props) => {
  const { metrics } = props.optionsResults;
  const {
    tradableSignals,
    noValidExpiryCount,
    noValidExpiryRate,
    calendarSuccessRate,
    lostToExpiryCount,
    lostToExpiryRate,
    avgExpiryBufferDays,
    weekendGapEntryCount,
    weekendGapEntryRate,
    expiryWeekdays,
  } = metrics.calendarTradability;

  return (
    <GenericCard
      title="Calendar-aware Tradability"
      tooltipText="Success Rate (top) assumes you can exit any bar. This checks whether the nearest real expiry actually covers your full hold window (maxDays) -- a contract that expires LATER than your hold window is fine (that's buffer, not a problem); one that expires BEFORE it means you could be forced out worthless. Toggle 'Mon/Wed/Fri expiries' to see how much the wider expiry calendar helps."
    >
      <div>
        <h5>Expiry cycle assumed</h5>
        <h4>{expiryWeekdays === "monWedFri" ? "Mon / Wed / Fri" : "Friday only"}</h4>
      </div>
      <div className="pt-2">
        <h2>{calendarSuccessRate}%</h2>
        <h5>success rate among {tradableSignals} tradable signals</h5>
      </div>
      <div className="pt-2 flex gap-8">
        <div>
          <h5>Not enough runway</h5>
          <h3 className={returnUpDownClassname(-noValidExpiryRate)}>
            {noValidExpiryRate}%{" "}
            <span className="text-xs">({noValidExpiryCount})</span>
          </h3>
        </div>
        <div>
          <h5>Hit missed (no runway)</h5>
          <h3 className={returnUpDownClassname(-lostToExpiryRate)}>
            {lostToExpiryRate}%{" "}
            <span className="text-xs">({lostToExpiryCount})</span>
          </h3>
        </div>
      </div>
      <div className="pt-2 flex gap-8">
        <div>
          <DashedTooltip text="Average bars of buffer past your hold window the chosen contract gives you, among tradable signals -- e.g. 1 means the expiry typically lands a day after you'd have sold anyway.">
            <h5>Avg buffer</h5>
          </DashedTooltip>
          <h3>{avgExpiryBufferDays} bars</h3>
        </div>
        <div>
          <DashedTooltip text="How often the entry's first trading bar is more than a calendar day away -- a Friday entry skipping straight to Monday, or an entry right before a holiday. The position sits through closed-market time (and theta decay) before it can react at all -- informational, not counted against tradability, since how much it matters depends on the stock.">
            <h5>Immediate weekend/gap</h5>
          </DashedTooltip>
          <h3 className={returnUpDownClassname(-weekendGapEntryRate)}>
            {weekendGapEntryRate}%{" "}
            <span className="text-xs">({weekendGapEntryCount})</span>
          </h3>
        </div>
      </div>
    </GenericCard>
  );
};

CalendarTradabilityCard.propTypes = { optionsResults: PropTypes.object };

export default CalendarTradabilityCard;
